import Image from "next/image";
import { useState } from "react";

const UspHugeShortageMobile = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  return (
    <>
      <div className="w-full pt-[35px] md-px-0 px-5 pb-[35px] bg-[#061A2F] bg-[url('/accounting/huge_shortage_bg.png')] bg-cover bg-[center_bottom_5px] relative">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0">
          <div className="flex justify-center items-center">
            <div
              className="relative w-[328px] h-[178px] flex items-center justify-center"
              onClick={() => {
                openPopup("jLTrZfJfO_M");
              }}
            >
              <Image
                src="/images/accounting/usp/shortage.png"
                alt="Accountants"
                className="mx-auto w-[328px] h-[170px] z-30"
                width={500}
                height={281}
              />

              <div className="flex items-center justify-center md:rounded-[15px] rounded-[15px] absolute left-0 right-0 bottom-[28%]">
                <Image
                  src="/images/accounting/usp/video-icon.png"
                  alt="Accountants"
                  className="cursor-pointer w-[50px] z-30"
                  width={110}
                  height={110}
                />
              </div>
            </div>
          </div>
        </div>

        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UspHugeShortageMobile;
